/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Hashes are computed locally with the Web Crypto API — your text never leaves your browser.`)
};

const es_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Los hash se calculan localmente con la Web Crypto API —tu texto nunca sale de tu navegador.`)
};

const de_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Hashes werden lokal mit der Web Crypto API berechnet — Ihr Text verlässt Ihren Browser niemals.`)
};

const nl_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Hashes worden lokaal berekend met de Web Crypto API — uw tekst verlaat uw browser nooit.`)
};

const fr_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Les hash sont calculés localement avec l'API Web Crypto — votre texte ne quitte jamais votre navigateur.`)
};

const it_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Gli hash vengono calcolati localmente con l'API Web Crypto — il tuo testo non lascia mai il tuo browser.`)
};

const pt_br2_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Os hashes são calculados localmente com a Web Crypto API — seu texto nunca sai do seu navegador.`)
};

const pt_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Os hashes são calculados localmente com a Web Crypto API — o seu texto nunca sai do seu navegador.`)
};

const ja_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ハッシュはWeb Crypto APIを使用してローカルで計算されます—テキストはブラウザを離れることはありません。`)
};

const zh_hg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。哈希值通过 Web Crypto API 在本地计算——你的文本永远不会离开浏览器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq3_a", locale)
	if (locale === "en") return en_hg_faq3_a(inputs)
	if (locale === "es") return es_hg_faq3_a(inputs)
	if (locale === "de") return de_hg_faq3_a(inputs)
	if (locale === "nl") return nl_hg_faq3_a(inputs)
	if (locale === "fr") return fr_hg_faq3_a(inputs)
	if (locale === "it") return it_hg_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq3_a(inputs)
	if (locale === "pt") return pt_hg_faq3_a(inputs)
	if (locale === "ja") return ja_hg_faq3_a(inputs)
	return zh_hg_faq3_a(inputs)
};